<template>
 <div>
  <div class="detailsTitle" >
       <h4>流向管理</h4>
    </div>
   <div class="searchBox" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="110px" size="mini">
       <div class="searchBtnBox">
          <el-form-item btnCode="00KM0B0100"  v-if="btnFlg[0]"  >
            <el-button type="primary"  @click="addRegion">新增</el-button>
          </el-form-item>

          <el-form-item btnCode="00KM0B0200"  v-if="btnFlg[1]" >
            <el-button type="primary" @click="delDeiver">删除</el-button>
          </el-form-item>
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
       @row-click="handleRowClick"  style="width: 100%" height="100%"  center border>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
         <el-table-column label="操作"  width="55">
            <template slot-scope="scope">
              <el-button type="text" size="mini" btnCode="00KM0B0300"  v-if="btnFlg[2]"   @click="modifyRegion(scope.row)">修改</el-button>
            </template>
        </el-table-column>
        <el-table-column prop="showName" min-width="160"  :formatter="emptyFn" label="流向"></el-table-column>
       <el-table-column prop="remark" min-width="360" :formatter="emptyFn" label="备注"></el-table-column>
        <el-table-column prop="createUserName" width="120" :formatter="emptyFn" label="创建人"></el-table-column>
        <el-table-column prop="createTime" width="170" :formatter="dateTimeFormat"  label="创建时间"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,1000]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 新建修改 -->
    <el-dialog  :title="isAdd?'新增':'修改'"  :close-on-click-modal="false" :close-on-press-escape="false" class="jiaoyan" @close="closeDialog"   :visible.sync="dialogVisible" width="500px" center>
      <span>
         <el-form :inline="true" :rules="rules" :model="addFrom" ref="addFrom" class="demo-form-inline" label-width="130px" size="mini">
        <div class="inpBox">
              <el-form-item label="流向:" prop="showName" class="jiage" >
                 <el-input  placeholder="" maxlength="10" v-model="addFrom.showName"  ></el-input>
              </el-form-item>
           <el-form-item label="备注:" class="remark" prop="remark" >
              <el-input  placeholder="" type="textarea" rows="3"  maxlength="20" v-model="addFrom.remark"></el-input>
            </el-form-item>
        </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveFn('addFrom')">确 定</el-button>
      </span>
    </el-dialog>
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { sShipDictionaryList, sShipDictionaryADD, sShipDictionaryUpdate, sShipDictionaryDelete } from '@/api/shipping'
import { emptyFn, dateTimeFormat } from '@/utils/util'
import mapAddress from '@/components/common/mapAddress.vue'
export default {
  components: {
    mapAddress
  },
  data () {
    return {
      h: 500,
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      title: '新建',
      dialogVisible: false,
      checkList: [],
      tableList: [],

      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      total: 0,
      ids: [],
      loading: 'false',
      rules: {
        showName: [
          { required: true, message: '请输入流向名称', trigger: 'blur' }
        ]
      },
      addFrom: {},
      flag: true, // 控制组件
      btnFlg: [],
      btnIdArr: ['00KM0B0100', '00KM0B0200', '00KM0B0300']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr)
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 98) + 'px'
  },
  methods: {
    // 选择数据
    selectGoods (selection) {
      console.log(selection)
      this.weight = 0.00
      selection.forEach(item => {
        this.weight += item.weight
      })
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true

      searchFrom.groupNo = 'ship_flow'
      sShipDictionaryList(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 添加
    addRegion () {
      this.title = '新建'
      this.addFrom = {}
      this.dialogVisible = true
      this.isAdd = true
      this.flag = true
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        createTime: null
      }
    },
    // 修改
    modifyRegion (row) {
      // this.addFrom = JSON.parse(JSON.stringify(row))

      this.$set(this.addFrom, 'showName', row.showName)
      this.$set(this.addFrom, 'remark', row.remark)
      this.$set(this.addFrom, 'id', row.id)

      this.title = '修改'
      this.dialogVisible = true
      this.isAdd = false
      this.flag = true
    },
    saveFn (formName) {
      debugger
      this.addFrom.isDefault = 1
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.isAdd) {
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            sShipDictionaryADD(this.addFrom).then(res => {
              loading.close()
              this.$message({
                message: '添加成功',
                type: 'success'
              })
              this.dialogVisible = false
              this.getList(this.searchFrom)
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          } else {
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            sShipDictionaryUpdate(this.addFrom).then(res => {
              loading.close()
              this.$message({
                message: '修改成功',
                type: 'success'
              })
              this.dialogVisible = false
              this.getList(this.searchFrom)
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                duration: 0,
                onClose () {
                  loading.close()
                }
              })
            })
          }
        } else {
          return false
        }
      })
    },
    // 删除
    delDeiver () {
      const selectData = this.$refs.table.selection
      if (selectData.length != 1) {
        this.$alert('请选择一条要操作的数据', '系统提示')
      } else {
        this.$confirm('是否执行删除操作?', '系统提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          sShipDictionaryDelete({ id: selectData[0].id }).then(res => {
            loading.close()
            this.$message({
              message: '删除成功',
              type: 'success'
            })
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }).catch(() => {

        })
      }
    },
    closeDialog () {
      this.addFrom = {}
      this.$refs.table.clearSelection()
      this.$refs.addFrom.clearValidate()
      this.flag = false
    },
    // 时间格式化
    dateFormat: function (row, column, cellValue) {
      var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
        t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
      var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
      var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
      var str = ''
      if (cellValue == null) {
        str = '-'
      } else {
        str =
          t.getFullYear() +
          '-' +
          month +
          '-' +
          date +
          ' ' +
          hour +
          ':' +
          minutes +
          ':' +
          seconds
      }
      return str
      // return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate(); // 年月日
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.inpBox .el-date-editor{
      width: 350px!important;
      display: flex;
}
.imgBox{
  display: flex;
  .item{
    display: flex;
     width: 50%;
     justify-content: space-around;
  }
}
/deep/ .checkboxBox{
  display: flex;
  label{
    flex-shrink: 0;
  }
  .el-checkbox-group{
    width:250px ;
  }
  .jiage{
  position: relative;
}
}

</style>
